import { FC } from 'react';
import { Icon } from '../../Icon';
import styles from './TableEmptyState.module.css';

interface TableEmptyStateProps {
  emptyStateText?: string;
}

export const TableEmptyState: FC<TableEmptyStateProps> = ({ emptyStateText = 'There is no results.' }) => {
  return (
    <div className={styles.container}>
      <Icon name="search" size={48} className={styles.icon} />
      <p className={styles.description}>{emptyStateText}</p>
    </div>
  );
};
